module.exports = __webpack_public_path__ + "img/galery5.8611c61c.jpg";